<template>
  <div class="home">
    <Monitor />
  </div>
</template>

<script>
// @ is an alias to /src
import Monitor from "@/views/Monitor.vue";

export default {
  name: "home",
  components: {
    Monitor
  }
};
</script>
